import { useMutation } from "@tanstack/react-query";
import AIToolsAPI from "../../api/AIToolsAPI";

interface QuestionGeneratorProps {
  text: string;
  questionCount?: number;
  questionType?: string;
  powered: "open-ai" | "brie";
  //   onSuccess: any;
}

const useQuestionGenerator = () => {
  const questionGenerator = useMutation({
    mutationFn: ({
      text,
      questionCount,
      questionType,
      powered,
    }: QuestionGeneratorProps) => {
      if (powered === "open-ai" && questionCount && questionType) {
        return AIToolsAPI.questionGenerator(text, questionCount, questionType);
      } else {
        return AIToolsAPI.brieQuestionGenerator(text);
      }
    },
  });

  return {
    questionGenerator: questionGenerator.mutate,
    questionGeneratorLoading: questionGenerator.isPending,
    questionGeneratorError: questionGenerator.error,
    questionGeneratorValue: questionGenerator.data?.data.data.question,
  };
};

export default useQuestionGenerator;
